__turbopack_context__.v({
  "add-contact-fields-message": "EmailSignatureEditorContactSection-module-scss-module__8b67fq__add-contact-fields-message",
  "new-contact-fields-section": "EmailSignatureEditorContactSection-module-scss-module__8b67fq__new-contact-fields-section",
  "new-contact-fields-section-wrapper": "EmailSignatureEditorContactSection-module-scss-module__8b67fq__new-contact-fields-section-wrapper",
});
